/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer';
import Header from './Header';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
import CustomBreadcrumb from './Breadcrumb';
import CustomPagination from './CustomPagination';
import EmptyState from './EmptyState';
import CustomTabs from './CustomTabs';
import FormFooter from './FormFooter';
import CustomModal from './CustomModal';
import CustomDelModal from './CustomModal/remove'; 
import CustomInfoModal from './CustomModal/info'; 
import ImportModal  from './CustomModal/ImportModal';
import _ from 'lodash';

const trimS = (value: any) => {
  // 如果是数值（包括 0），不作处理
  if (typeof value === 'number') {
    return value;
  }
  
  // 如果是字符串
  if (typeof value === 'string') {
    const trimmed = _.trim(value);
    // 如果是空字符串，返回 null
    return trimmed === '' ? null : trimmed;
  }
  
  // 其他类型保持原样
  return value;
};
export { trimS, Header, AvatarDropdown, AvatarName, Footer, Question, SelectLang, CustomBreadcrumb, CustomPagination, EmptyState, CustomTabs, FormFooter, CustomModal,CustomDelModal,CustomInfoModal,ImportModal,_ };
